import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profiling-add',
  templateUrl: './profiling-add.component.html',
  styleUrls: ['./profiling-add.component.css'],
  standalone: false
})
export class ProfilingAddComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

  toolbarClick(item) {

    const filename = 'license_export';
  }

}
